// extracted by mini-css-extract-plugin
export default {"floating_button":"floating-button_bolao_floating_button__6JtdO"};